export default class pegOtpHelpDialog extends HTMLElement {
	connectedCallback() {
		this.abortController = new AbortController();
		this.#setEventListeners();
	}

	disconnectedCallback() {
		this.abortController.abort();
	}

	#setEventListeners() {
		this.querySelector('#resendButton').addEventListener(
			'click',
			() => {
				this.#resendCode();
				this.#trackClickResendCode();
			},
			{ signal: this.abortController.signal },
		);

		this.querySelector('#openOscHelpPages').addEventListener(
			'click',
			() => {
				this.#trackOpenOscHelpPages();
			},
			{ signal: this.abortController.signal },
		);

		this.querySelector('#cancelButton').addEventListener(
			'click',
			() => {
				this.#trackCancelHelpOverlay();
			},
			{ signal: this.abortController.signal },
		);
	}

	async #resendCode() {
		try {
			const data = {
				_csrf: jPar.wdk.security.csrf.getToken(),
				userId: this.getAttribute('user-id'),
			};
			const response = await fetchIt.post('/user/verification/oneTimePassword/resend', JSON.stringify(data));

			if (jPar.util.network.hasValidSessionAndCsrfToken(response)) {
				if (response.success) {
					document.querySelector('wdk-dialog#resendSuccessModal').openModal();
					this.#trackClickResendCodeSuccessful();
				} else {
					// possible errorCodes: VERIFICATION_NOT_NEEDED, GENERAL_ERROR
					if (response.errorCode === 'VERIFICATION_NOT_NEEDED') {
						document.querySelector('wdk-dialog#resendVerificationNotNeededModal').openModal();
					} else {
						document.querySelector('wdk-dialog#resendBlockedModal').openModal();
					}
				}
			} else {
				jPar.wdk.modalbox.show({ modalboxId: 'errorModalbox500' });
			}
		} catch (error) {
			jPar.util.network.defaultErrorHandling(error);
		}
	}

	#trackClickResendCodeSuccessful() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'otp_verification_screen',
			action: 'code_sent',
		});
	}

	#trackClickResendCode() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'otp_verification_screen',
			action: 'click',
			targetId: 'button_resend_code',
		});
	}

	#trackOpenOscHelpPages() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'otp_verification_screen',
			action: 'click',
			targetId: 'button_visit_help_center',
		});
	}

	#trackCancelHelpOverlay() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'otp_verification_screen',
			action: 'click',
			targetId: 'button_cancel',
		});
	}
}
